import { Ui } from '../../shared/enum/ui/ui';

export class BottomPanel {
  constructor(public active: boolean = false, public collapseStatus: Ui.CollapseStatus) {}
}
